import React, { Component } from "react"
import {
  Button,
  Segment,
  Grid,
  Icon,
  Header,
  Form,
  Divider
} from "semantic-ui-react"
import { translate } from "react-translate"
import { Link } from "react-router-dom"

import "./QuestionSuggestion.css"

class QuestionSuggestion extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { t } = this.props

    return (
      <Segment vertical id="BlockQuestionSuggestion">
        <Segment vertical textAlign="center" id="seventhContentInside">
          <Header size="medium" as="h2" id="seventhContentTitleTitlePro">
            {t("Segment7_title")}
          </Header>
          <Header
            as="p"
            textAlign="center"
            id="seventhContentTitleDescriptionPro"
          >
            {t("Segment7_description")}
          </Header>
        </Segment>

        <Segment vertical id="seventhContentInside">
          <Grid stackable columns={2} centered padded>
            <Grid.Row>
              <Grid.Column
                textAlign="right"
                id="seventhLeftColumn"
                mobile={16}
                tablet={8}
                computer={5}
              >
                <Grid centered columns={2}>
                  <Grid.Column width={2}>
                    <Icon inverted name="map pin" />
                  </Grid.Column>
                  <Grid.Column width={12} id="dashedBorderPro">
                    <Header as="a" id="seventhContentLeftAddressePro">
                      {t("Segment7_address")}
                    </Header>
                  </Grid.Column>
                </Grid>
                <Grid centered columns={2} style={{ paddingTop: "30px" }}>
                  <Grid.Column width={2}>
                    <Icon inverted name="phone" />
                  </Grid.Column>
                  <Grid.Column width={12} id="dashedBorderPro">
                    <Header as="p" id="seventhContentLeftPhonePro">
                      {t("Segment7_phone1")}
                    </Header>
                    <Header as="p" id="seventhContentLeftPhonePro">
                      {t("Segment7_phone2")}
                    </Header>
                  </Grid.Column>
                </Grid>
                <Grid centered columns={2} style={{ paddingTop: "30px" }}>
                  <Grid.Column width={2}>
                    <Icon inverted name="mail" />
                  </Grid.Column>
                  <Grid.Column width={12}>
                    <Header as="a" id="seventhContentLeftMailPro">
                      {t("Segment7_mail")}
                    </Header>
                  </Grid.Column>
                </Grid>
              </Grid.Column>

              <Grid.Column
                textAlign="left"
                id="seventhForm"
                mobile={16}
                tablet={8}
                computer={5}
              >
                <Form onSubmit={this.submitContact}>
                  <Grid.Row>
                    <Form.Input
                      placeholder="Votre Nom"
                      id="inputFormNameContactPro"
                      onChange={this.onChangeNameContactUs}
                    />
                  </Grid.Row>
                  <Divider hidden />
                  <Grid.Row>
                    <Form.Input
                      placeholder="Votre Email"
                      type="email"
                      id="inputFormMailContactPro"
                      onChange={this.onChangeMailContactUs}
                    />
                  </Grid.Row>
                  <Divider hidden />
                  <Grid.Row>
                    <Form.TextArea
                      placeholder="Votre message !"
                      id="inputFormTextContactPro"
                      onChange={this.onChangeTextContactUs}
                    />
                  </Grid.Row>
                  <Divider hidden />
                  <p style={{ color: "black" }}>
                    <input type="checkbox" required name="terms" />{" "}
                    {t("terms_agreement")}{" "}
                    <Link style={{ color: "white" }} to="/termsandconditions">
                      {t("termsandconditions")}
                    </Link>
                    .{" "}
                  </p>
                  <Grid.Row>
                    <Button
                      type="submit"
                      id="inputFormButtonContactPro"
                      circular
                      fluid
                    >
                      <Header as="a" style={{ color: "white" }}>
                        {t("Segment7_button")}
                      </Header>
                    </Button>
                  </Grid.Row>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Segment>
    )
  }
}

export default translate("LandingComponent")(QuestionSuggestion)



// WEBPACK FOOTER //
// ./src/components/Pro/AcceuilLandingPage/QuestionSuggestion.js